/* esm.sh - @radix-ui/primitive@1.1.3 */
export * from "/*@radix-ui/primitive@1.1.3/esnext/primitive.mjs";
